export const config: any = {
    pageAddress: "https://hiveslotgames.com",
    gameServerAddress: "https://dice-server.hiveslotgames.com",
    gameId: "Hive_Dice",
    minBet: 0.1,
    maxBet: 200,
    maxWinAllowed: 1500,
    displayCurrency: "HIVE",
    baseCurrency: "mHIVE",
    baseCurrencyDenomination: 1000,
    betDisplayPrecision: 3,
};



// WEBPACK FOOTER //
// ./src/config.ts